import { getTranslation } from '@/services/api'
import type { TranslateReq } from '@/services/api/common/type'
import { OneMessage } from '@yy/one-ui'
import { useRequest } from 'ahooks'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

type TranslateMapType = Record<string, Record<string, string>>

/** 获取翻译数据 */
export function useGetTranslate() {
  const { t } = useTranslation()

  const { run, loading } = useRequest(getTranslation, {
    manual: true,
    formatResult: (res) => {
      const { data } = res
      if (!data || !data.translateList || data.translateList.length === 0) {
        OneMessage.info(t('good.translation.fail'))
        return null
      }

      // 将数据转成一个对象，便于读取
      const { translateList: list } = data
      const translateMap = list.reduce((map, cur) => {
        const lan = cur.targetLanguage

        cur.texts?.map((item) => {
          if (!map[lan]) {
            map[lan] = { [item.source]: item.target }
          } else {
            map[lan][item.source] = item.target
          }
        })

        return map
      }, {} as TranslateMapType)

      return translateMap
    },
    onError: (err) => {
      const { code, message } = err || ({} as any)
      if (code === '-1002') {
        OneMessage.info(t('good.translation.fail'))
      } else if (message) {
        OneMessage.error(message)
      }
    },
  })

  const startTranslate = useCallback(
    async (params: TranslateReq, successCallback: (res: TranslateMapType) => void) => {
      OneMessage.info(t('common.translating'))
      const data = await run(params)
      if (data) {
        successCallback(data)
      }
    },
    [run, t]
  )

  return {
    startTranslate,
    loading,
  }
}
